export enum RfcType {
    BOM = "BOM",
    STOCK_AND_PO = "STOCK_PO",
    FORECAST = "FORECAST",
    PRICE = "PRICE",
}
